import React from 'react'
import {Box} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {Phone} from '@mui/icons-material'
import styled from 'styled-components'
import {WhiteArea} from './BillingDataCommon'
import {DisplayItemTitle} from '../../../../styledComponents/DisplayItem'
import {Colors, FontSize, FontWeights} from '../../../../styledComponents/Constants'
import {LeftRowFlexContainer} from '../../../../styledComponents/FlexComponents'
import {Messages} from '../../../../Messages'
import {SmallPlainLinkStyledButton} from '../../../../styledComponents/Button'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faExternalLinkAlt} from '@fortawesome/free-solid-svg-icons'
import {HKConstants} from '../../../../HKConstants'

const NatResidentBillingDataContactUs = () => {
    return <>
        <WhiteArea>
            <DisplayItemTitle>お問い合わせ先</DisplayItemTitle>
            <Box height={'15px'}/>
            <Box fontSize={FontSize.Middle}>長谷工コンタクトセンター</Box>
            <Box height={'5px'}/>
            <LeftRowFlexContainer>
                <BluePhone fontSize={'large'}/>
                <Box width={'12px'}/>
                <Box fontSize={FontSize.Accent} fontWeight={FontWeights.Bold} color={Colors.AccentDark}>
                    {Messages.IRESR0007.toString()}
                </Box>
            </LeftRowFlexContainer>
            <Box height={'4px'}/>
            <AlignItemsStartFlexContainer>
                <Box>受付時間</Box>
                <Box width={'10px'}/>
                <NewLineContents>{Messages.IRESR0014.toString()}</NewLineContents>
            </AlignItemsStartFlexContainer>
            <Box height={'10px'}/>
            <SmallPlainLinkStyledButton
                onClick={() => window.open(HKConstants.VRS.SYS.CONTACT_WEB_URL_MANSION, '_blank')}>
                <LeftRowFlexContainer>
                    <FontAwesomeIcon icon={faExternalLinkAlt}/>
                    <Box width={'10px'}/>
                    お問い合わせフォーム
                </LeftRowFlexContainer>
            </SmallPlainLinkStyledButton>
            <Box height={'10px'}/>
        </WhiteArea>
    </>
}

NatResidentBillingDataContactUs.displayName = 'NatResidentBillingDataContactUs'
export default NatResidentBillingDataContactUs

const BluePhone = withStyles({
    root: {
        color: Colors.Primary,
    }
})(Phone)

const AlignItemsStartFlexContainer = styled(LeftRowFlexContainer)`
    align-items: flex-start;
    font-Size: ${FontSize.Small};
`
const NewLineContents = styled.div`
    white-space: pre;
`
